var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatbotOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82.1 111.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #3d60aa;\n      }\n\n      .cls-3 {\n        fill: #f3a6c8;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,0v71.05h0v.75c0,21.95,18.38,39.75,41.05,39.75s41.05-17.8,41.05-39.75c0-18.49-13.03-34.03-30.68-38.47.48-2.05.74-4.2.74-6.41,0-.29,0-.58-.01-.86C51.71,11.47,39.48,0,24.89,0,24.89,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M79.48,10.45c0,5.45-4.42,9.87-9.87,9.87s-9.87-4.42-9.87-9.87S64.16.58,69.61.58s9.87,4.42,9.87,9.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M63.16,88.34c0,1.89-1.53,3.42-3.42,3.42s-3.42-1.53-3.42-3.42,1.53-3.42,3.42-3.42,3.42,1.53,3.42,3.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.83,88.34c0,1.89-1.53,3.42-3.42,3.42s-3.42-1.53-3.42-3.42,1.53-3.42,3.42-3.42,3.42,1.53,3.42,3.42"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.69,71.27c0-3.5-2.11-6.51-5.13-7.84,1.05-.46,2.21-.72,3.43-.72,4.72,0,8.56,3.83,8.56,8.56s-3.83,8.56-8.56,8.56c-1.22,0-2.38-.26-3.43-.72,3.02-1.32,5.13-4.33,5.13-7.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.43,71.27c0-3.5,2.11-6.51,5.13-7.84,3.02,1.32,5.13,4.33,5.13,7.84s-2.11,6.51-5.13,7.84c-3.02-1.32-5.13-4.33-5.13-7.84Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.11,71.27c0-3.56-2.18-6.62-5.28-7.9,1.01-.42,2.12-.65,3.28-.65,4.72,0,8.56,3.83,8.56,8.56s-3.83,8.56-8.56,8.56c-1.16,0-2.27-.23-3.28-.65,3.1-1.29,5.28-4.34,5.28-7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.56,71.27c0-3.56,2.18-6.62,5.28-7.9,3.1,1.29,5.28,4.34,5.28,7.9s-2.18,6.62-5.28,7.9c-3.1-1.29-5.28-4.34-5.28-7.9Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.64,75.64c.51,1.95,2.37,3.44,4.4,3.45s3.9-1.47,4.42-3.41c.25-.93-1.19-1.33-1.45-.4-.36,1.31-1.61,2.31-2.98,2.31s-2.61-1.04-2.95-2.34c-.25-.93-1.69-.54-1.45.4h0Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotOpen);
export default __webpack_public_path__ + "static/media/CHATBOT_OPEN.0a27ecdf40e0bcc8d536ab822fe6b3e9.svg";
export { ForwardRef as ReactComponent };